import { Link } from 'react-router-dom'
import { ArrowUpRight } from 'lucide-react'
import {
  useCommissionAccess,
  useCommissionDeal,
  useCommissionSurgery,
} from '../../shared/api/generated/commercial-commissions/commercial-commissions'
import { CommissionTable } from './CommissionTable'
import { errorMessage } from './helpers'
import './commissions.css'

/** Card embutido na página do deal (e cirurgia, quando o host o incluir). */
export function CommissionCard({
  proposalId,
  surgeryId,
}: {
  proposalId?: number
  surgeryId?: number
}) {
  const access = useCommissionAccess({ query: { retry: false } })
  const canAccess = !!access.data?.can_read || !!access.data?.can_review
  const deal = useCommissionDeal(proposalId ?? 0, {
    query: { enabled: !!proposalId && canAccess, retry: false },
  })
  const surgery = useCommissionSurgery(surgeryId ?? 0, {
    query: { enabled: !!surgeryId && canAccess, retry: false },
  })
  const query = proposalId ? deal : surgery
  if (!canAccess || !access.data || (query.isError && !access.data.can_review)) return null
  const rows = query.data ? [...query.data.entries, ...query.data.pending] : []
  return (
    <section className="cc-card cc-embedded">
      <div className="cc-card-head">
        <div>
          <h2>Comissão comercial</h2>
          <p>Parcelas geradas para este caso.</p>
        </div>
        <Link
          className="cc-inline-link"
          to={
            access.data.can_manage
              ? '/comissoes-comercial'
              : access.data.can_read_own
                ? '/minhas-comissoes'
                : '/minhas-comissoes/pendencias'
          }
        >
          Relatório <ArrowUpRight size={13} aria-hidden="true" />
        </Link>
      </div>
      {query.isLoading && (
        <div className="cc-empty" role="status">
          Carregando comissões…
        </div>
      )}
      {query.isError && (
        <p className="cc-notice cc-error cc-notice-inset" role="alert">
          {errorMessage(query.error)}
        </p>
      )}
      {query.data && (
        <CommissionTable
          rows={rows}
          emptyTitle="Nenhuma parcela gerada para este caso."
          emptyHint="As parcelas aparecem após a apuração do mês correspondente."
        />
      )}
    </section>
  )
}
